import PropTypes from "prop-types";
import LeadSourceRow from "./LeadSourceRow";
import LeadSourceTotalRow from "./LeadSourceTotalRow";

const LeadSourcesHolder = ({ sources, isOtherSource, statusCounts, totalLeadCount }) => (
  <>
    {sources?.map((s, i) => (
      // eslint-disable-next-line react/no-array-index-key
      <LeadSourceRow key={i} source={s} isOtherSource={isOtherSource} />
    ))}
    {statusCounts && <LeadSourceTotalRow statusCounts={statusCounts} totalLeadCount={totalLeadCount} />}
  </>
);

LeadSourcesHolder.propTypes = {
  sources: PropTypes.arrayOf(PropTypes.shape()),
  isOtherSource: PropTypes.bool,
  statusCounts: PropTypes.shape(),
  totalLeadCount: PropTypes.number,
};

LeadSourcesHolder.defaultProps = {
  sources: [],
  isOtherSource: false,
  statusCounts: {},
  totalLeadCount: 0,
};

export default LeadSourcesHolder;
